import isDevelopment from '../utils/isDevelopment';

const localUrl = '127.0.0.1:3000';
const serverUrl = 'wfm.net92.ru';
const url = isDevelopment() ? localUrl : serverUrl;

export const IdentityBaseUrl = `https://${url}/identity-client/api/auth`;
export const BaseUrl = `https://${url}/wfm/api/v1`;
export const BaseFiasUrl = `https://${url}/api/fias`;
